export function setCookie(cname, cvalue) {
  const exdays = 30;
  let secure = '';
  if (window.location.protocol === 'https') {
    secure = '; secure';
  }
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + '; ' + expires + secure + '; path=/; SameSite=Lax';
}

export function getCookie(cname) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (String(c.charAt(0)) === ' ') {
      c = c.substring(1);
    }
    if (Number(c.indexOf(name)) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

export function deleteCookie(cname) {
  document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
}

export function deleteAllCookies() {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
}

export const emailValidation = (value) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase());
};

export const isFormValid = (formValidity) => {
  return Object.values(formValidity).every((item) => Boolean(item) === true);
};

export const showHideModal = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (el.dataset.bsToggle === 'modal' || el.getAttribute('data-bs-toggle') === 'modal') {
    el.click();
  } else {
    const modalEl = document.getElementById(id.replace('-button', ''));
    if (modalEl) {
      const bsModal =
        window.bootstrap?.Modal?.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
      bsModal.toggle();
    }
  }
};
